import React from 'react';
import { Table } from 'react-bootstrap';
import { ExtraReportResponse } from '../../../../services/extra-report/response/ExtraReportResponse';

interface ExtraTableReportProps {
    data: ExtraReportResponse;
}

const ExtraTableReport: React.FC<ExtraTableReportProps> = ({ data }) => {
    const formatCurrency = (amount: string) => {
        const num = parseFloat(amount) || 0;
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            maximumFractionDigits: 0,
        }).format(num).replace('Rp', 'Rp.').trim();
    };

    return (
        <div className="mt-4">
            <h5>Extra Report</h5>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Invoice</th>
                        <th>Guest Name</th>
                        <th>Room</th>
                        <th>Item Name</th>
                        <th>Qty</th>
                        <th>Amount</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {data.data.length === 0 && (
                        <tr>
                            <td colSpan={8} className="text-center">No data available</td>
                        </tr>
                    )}
                    {data.data.map((item, index) => (
                        <tr key={`${item.booking_room_id}-${item.date}-${index}`}>
                            <td>{index + 1}</td>
                            <td>{item.invoice_number || '-'}</td>
                            <td>{item.customer_full_name || '-'}</td>
                            <td>{item.room_type_name || '-'}</td>
                            <td>{item.product}</td>
                            <td>{item.quantity}</td>
                            <td>{formatCurrency(item.amount)}</td>
                            <td>{new Date(item.date).toLocaleDateString()}</td>
                        </tr>
                    ))}
                </tbody>
                {data.total_qty !== undefined && data.total_amount !== undefined && (
                    <tfoot>
                        <tr className="fw-bold">
                            <td colSpan={5} className="text-end">Total:</td>
                            <td>{data.total_qty}</td>
                            <td>{formatCurrency(data.total_amount)}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                )}
            </Table>
        </div>
    );
};

export default ExtraTableReport;
